import {
  defaultCabinClass,
} from "@/schemas/passengerSchema";

const today = new Date();

// Bus için default passenger counts
// Bus passenger types: adult, young, child
const defaultBusPassengerCounts = {
  adult: 1,
  young: 0,
  child: 0,
};

// Bus için initial state - sadece gerekli alanlar
export const initialState = {
  loading: false,
  departureDate: today, // Varsayılan bugün, useTomorrowAsDefault flag'i ile yarın yapılabilir
  departureCity: null,
  returnCity: null,
  passengers: defaultBusPassengerCounts,
  cabinClass: defaultCabinClass, // Bus için de cabin class var (normal, vip vb.)
  latestBusSearches: null,
  popularCities: null,
  publicHolidays: [],
  useTomorrowAsDefault: false, // Varsayılan tarih seçimi için flag (false: bugün, true: yarın)
};

export const busSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_DEPARTURE_DATE":
      return { ...state, departureDate: action.payload };
    case "SET_DEPARTURE_CITY":
      return { ...state, departureCity: action.payload };
    case "SET_RETURN_CITY":
      return { ...state, returnCity: action.payload };
    case "TOGGLE_DEPARTURE_AND_RETURN":
      return {
        ...state,
        departureCity: state.returnCity,
        returnCity: state.departureCity,
      };
    case "SET_PASSENGERS_AND_CABIN_CLASS":
      return {
        ...state,
        passengers: action.payload.passengers,
        cabinClass: action.payload.cabinClass,
      };
    case "SET_LATEST_FLIGHT_SEARCHES": // Backward compatibility için
    case "SET_LATEST_BUS_SEARCHES":
      return { ...state, latestBusSearches: action.payload };
    case "SET_POPULAR_CITIES":
      return { ...state, popularCities: action.payload };
    case "SET_PUBLIC_HOLIDAYS":
      return { ...state, publicHolidays: action.payload };
    case "SET_USE_TOMORROW_AS_DEFAULT":
      return { ...state, useTomorrowAsDefault: action.payload };
    default:
      return state;
  }
};

export default busSearchReducer;
